/* eslint-disable react/jsx-props-no-spreading */
import '../../polyfills/fetch';
import React, { useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { SnackbarProvider } from 'notistack';
import Cookies from 'js-cookie';
import 'bootstrap/dist/css/bootstrap.css';
import '../../scss/app.scss';
import LanguageContext from '../../languagecontext';
import localeData from '../../translations/language.json';
import Router from './Router';
import store from './store';
import ScrollToTop from './ScrollToTop';
import Notifier from '../Layout/snackbar/Notifier';

let defLanguage;

if (Cookies.get('language')) {
  defLanguage = Cookies.get('language');
} else {
  defLanguage = (navigator.languages && navigator.languages[0])
    || navigator.language || navigator.userLanguage;
}
// const defLanguageWithoutRegionCode = defLanguage.toLowerCase().split(/[_-]+/)[0];
// const defMessages = localeData[defLanguageWithoutRegionCode]
// || localeData[defLanguage] || localeData.en;

const App = () => {
  const toggleLanguage = (language) => {
    const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
    const messages = localeData[languageWithoutRegionCode]
      || localeData[defLanguage] || localeData.en;
    return {
      language: languageWithoutRegionCode,
      messages,
    };
  };

  const [locales] = useState(toggleLanguage(defLanguage));

  return (
    <LanguageContext.Provider value={locales}>
      <IntlProvider locale={locales.language} messages={locales.messages}>
        <Provider store={store}>
          <SnackbarProvider maxSnack={10}>
            <Notifier />
            <BrowserRouter>
              <ScrollToTop>
                <Router />
              </ScrollToTop>
            </BrowserRouter>
          </SnackbarProvider>
        </Provider>
      </IntlProvider>
    </LanguageContext.Provider>
  );
};

export default hot(module)(App);
